import SectionBuilderConfig from 'molecules/Section/Section.config';

const integrationsBuilderDataField = {
  name: 'IntegrationsList',
  inputs: [{ name: 'enableDoodle', type: 'boolean' }],
  ...SectionBuilderConfig.inputs,
};

export default integrationsBuilderDataField;
